import React from 'react'

import { Button, Card, Icon, Modal, Row, Typography } from 'antd'
import moment from 'moment'

import AlertIcon from '../../../assets/images/ico_erro.svg'
import { api, request } from '../../../util/handlerRequestUtil'
import { getMessage } from '../../../util/IntlMessages'
import { STATUS } from '../../../util/walletStatus'
import { validateCanEditWalletByProfileId, validateCanEditWalletByRange } from '../utils'

const { confirm } = Modal

const WalletStatusCard = ({ state, walletStatus, profileId, retrieveWalletStatus }) => {
  const {
    memberData,
    configuration: { clientEditionPeriodStartDate, clientEditionPeriodEndDate, clientQuantity }
  } = state
  const { district_name: district, member_name: memberName, customers_count } = memberData

  const formattedStartDate = moment(clientEditionPeriodStartDate).format('DD/MM/YYYY')
  const formattedEndDate = moment(clientEditionPeriodEndDate).format('DD/MM/YYYY')
  const startDate = clientEditionPeriodStartDate
  const endDate = clientEditionPeriodEndDate
  const canEditWalletByRange = validateCanEditWalletByRange(startDate, endDate, false)
  let closedPeriodLabel = null
  let cardStatus = null

  function submitWallet() {
    handleWalletStatus('Tem certeza que deseja submeter sua carteira para validação do GR?', STATUS.IN_VALIDATION)
  }

  function approveWallet() {
    handleWalletStatus(
      `Tem certeza que deseja aprovar a carteira do distrito ${state.memberData['district_name']}?`,
      STATUS.APPROVED
    )
  }

  function disapproveWallet() {
    handleWalletStatus(
      `Tem certeza que deseja solicitar a Revisão da carteira do distrito ${state.memberData['district_name']}?`,
      STATUS.TO_BE_REVIEWED,
      true
    )
  }

  async function handleWalletStatus(message, newStatus, regress = false) {
    confirm({
      title: <img src={AlertIcon} alt="" style={{ marginLeft: '42%' }} />,
      icon: null,
      content: message,
      okText: 'Confirmar',
      cancelText: 'Cancelar',
      okButtonProps: {
        type: 'default'
      },
      cancelButtonProps: {
        type: 'default'
      },
      async onOk() {
        let response
        if (regress) {
          response = await request(api.regressWalletStatus(state.memberData['district_id'], newStatus))
        } else {
          response = await request(api.advanceWalletStatus(state.memberData['district_id'], newStatus))
        }
        if (response && response.idStatus) {
          retrieveWalletStatus()
        }
      }
    })
  }

  if (!canEditWalletByRange) {
    closedPeriodLabel = (
      <Typography className="card-closed-period">{`${getMessage('clientEditionPeriodClosed')}`}</Typography>
    )
  }

  async function downloadPdf() {
    await api.regionLinksPdfByDistrict(state.memberData['district_id'], state.memberData['member_id'])
  }

  if (!validateCanEditWalletByProfileId(profileId, false)) {
    cardStatus = (
      <Card className="card-sequence">
        <Typography className="card-title">{getMessage('walletStatus')}</Typography>
        {[1, 3].includes(walletStatus.id) && (
          <Row type="flex">
            <Button className="button-await">
              <Icon type="clock-circle" className="icons-cards" style={{ marginTop: 8 }} />
              {walletStatus.name}
            </Button>
            {canEditWalletByRange && (
              <Button className="button-aprove" onClick={submitWallet}>
                <Icon type="like" className="icons-cards" style={{ color: '#843ef7', marginTop: 8 }} />
                {getMessage('wallet.status.submit')}
              </Button>
            )}
          </Row>
        )}
        {walletStatus.id === 2 && (
          <Row type="flex">
            <Button className="button-await">
              <Icon type="clock-circle" className="icons-cards" />
              {getMessage('wallet.status.validating')}
            </Button>
          </Row>
        )}
        {walletStatus.id === 4 && (
          <Row type="flex">
            <Button className="button-await">
              <Icon type="like" className="icons-cards" style={{ marginTop: 8 }} />
              {getMessage('wallet.status.approved')}
            </Button>
            <Button onClick={downloadPdf} className="button-export">
              <Icon type="download" className="icons-cards" />
              {getMessage('exportPdf')}
            </Button>
          </Row>
        )}
        <Typography className="card-descriptions">
          {`${getMessage('WalletAprovation')} ${formattedStartDate} ${getMessage('until')} ${formattedEndDate}`}
        </Typography>
        {closedPeriodLabel}
      </Card>
    )
  } else {
    cardStatus = (
      <Card className="card-sequence">
        <Typography className="card-title">{getMessage('walletStatus')}</Typography>
        {[1, 3].includes(walletStatus.id) && (
          <Row type="flex">
            <Button className="button-await">
              <Icon type="clock-circle" className="icons-cards" />
              {walletStatus.name}
            </Button>
          </Row>
        )}
        {walletStatus.id === 2 && (
          <Row type="flex">
            {canEditWalletByRange ? (
              <>
                <Button className="button-reprove" onClick={approveWallet}>
                  <Icon type="like" className="icons-cards" style={{ color: '#fff', marginTop: 8 }} />
                  {getMessage('wallet.status.approve')}
                </Button>
                <Button className="button-aprove" onClick={disapproveWallet}>
                  <Icon type="dislike" className="icons-cards" style={{ color: '#843ef7', marginTop: 8 }} />
                  {getMessage('wallet.status.review')}
                </Button>
              </>
            ) : (
              <Button className="button-await">
                <Icon type="clock-circle" className="icons-cards" />
                {getMessage('wallet.status.validating')}
              </Button>
            )}
          </Row>
        )}
        {walletStatus.id === 4 && (
          <Row type="flex">
            <Button className="button-await">
              <Icon type="like" className="icons-cards" />
              {getMessage('wallet.status.approved')}
            </Button>
            <Button onClick={downloadPdf} className="button-export">
              <Icon type="download" className="icons-cards" />
              {getMessage('exportPdf')}
            </Button>
            {canEditWalletByRange && (
              <Button className="button-aprove" onClick={disapproveWallet}>
                <Icon type="dislike" className="icons-cards" style={{ color: '#843ef7', marginTop: 8 }} />
                {getMessage('wallet.status.review')}
              </Button>
            )}
          </Row>
        )}
        <Typography className="card-descriptions">
          {`${getMessage('WalletAprovation')} ${formattedStartDate} ${getMessage('until')} ${formattedEndDate}`}
        </Typography>
        {closedPeriodLabel}
      </Card>
    )
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <Card className="card-left">
        <Typography className="card-title">{getMessage('menuDistrict')}</Typography>
        <Button disabled className="district-name">
          {district}
        </Button>
        <Typography className="card-descriptions">{`${getMessage('memberId')}: ${
          memberName ? memberName : 'Sem profissional vinculado a carteira'
        }`}</Typography>
      </Card>
      <Card className="card-sequence">
        <Typography className="card-title">{getMessage('quantElect')}</Typography>
        <div className="div-status-card">
          <Icon type="star" className="icons-cards" style={{ marginTop: 10, marginRight: 3 }} />
          <Typography className="card-title-description">
            {customers_count} de {clientQuantity}
          </Typography>
        </div>
        <Typography className="card-descriptions">{getMessage('walletQuantelect', clientQuantity || 0)}</Typography>
      </Card>
      {cardStatus}
    </div>
  )
}

export default WalletStatusCard
